import { Field } from "typegraph";

export default class Stat {

	@Field()
	replies: number;

	@Field()
	flags: number;

	@Field()
	rating: number; //# rating total

	@Field()
	score: number; // # vote score +-1

	@Field()
	rates: number;

	@Field()
	votes: number;

	@Field()
	votePositive: number;

	@Field()
	voteNegative: number;

	@Field()
	views: number;

	@Field()
	comments: number; // number of comments
}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/Stat.ts